
import { emptyPerson, IPerson } from './person';
import { IAuthorized } from './authorized';

export interface IAuthorizedPerson extends  IAuthorized{
  authorizedPerson: IPerson;
}

export const emptyAuthorizedPerson: IAuthorizedPerson = {
  authorizedPerson: emptyPerson,

  id: -1,
  person: emptyPerson,
  type: '',
};




// WEBPACK FOOTER //
// ./src/app/model/authorized-person.ts